<template>
  <!--/*追忆 追思 追寻 */-->
  <div class="Remembrance">
    <!--包裹-->
    <div class="contentnr">
      <!--主体导航，筛选-->
      <div class="content">
        <div class="content-top-tab">
          <div class="content-top-tab-left">
            <div class="content-top-tab-zdlyzb" @click="handleTabQx('1')">“致敬”系列视频展播</div>
            <div class="content-top-tab-qmsp" @click="handleTabQx('2')">重点陵园展播</div>
          </div>
        </div>
        <!--列表-->
        <div class="resistance-content clearfix">
          <div v-show="isdata" class="over">暂无数据</div>
          <!--列表内容-->
          <ul>
            <li v-for="(item,index) in datalist">
              <div class="lsimg enlarge" style="position: relative">
                <img v-lazy=item.basicThumbnail @click="handleHerf(item.basicId)" alt="">
                <div class="play"></div>
              </div>
              <div class="lstext">
                <div class="lstext-text text-tow-overflow" v-html="item.basicTitle" :title="item.basicTitle"
                     @click="handleHerf(item.basicId)">
                  {{item.basicTitle}}
                </div>
            <!--    <div class="region">{{item.basicArea}}</div>-->
              </div>
            </li>
          </ul>
          <!--分页-->
          <paging v-show="!isdata" :dataall="screenfourpage.all" :dataCur="screenfourpage.cur"
                  :datanum="screenfourpage.num"
                  :dataDatanum="screenfourpage.dataNum"
                  @change="pageChange"></paging>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {ZDLYZB, ZJXLZB} from '@/config/global.js'
  import {getUserToken} from '@/config/config.js'
  import util from '@/assets/js/util'
  import Paging from '@/components/paging'
  import {getzdJsondata, getzjJsondata, getAjaxdata} from '@/api/Remembrance.js'

  export default {
    data() {
      return {
        isdata: false,
        /*区划*/
        basicAreaCode: "",
        /*栏目*/
        columnId: "",
        /*栏目选中*/
        Recollection: true,
        pursue: false,
        Reminiscence: false,
        sothelist: [],
        datalist: [],
        qmdata: [],
        zdlydata: [],
        /*分页数据*/
        screenfourpage: {
          all: '', //总页数
          cur: 1, //当前页码
          num: 10, //一页显示的数量  必须是奇数
          dataNum: '', //数据的数量
        },
        dqid: '1'
      }
    },
    components: {
      /*分页组件*/
      Paging,
    },
    mounted() {
      this.$on('bridge', (val) => {
        this.screenfourpage.cur = val
        if (this.datalist.length == 0) {
          this._handleObtainData(this.dqid);
        }
        setTimeout(()=>{
          $('.content-top-tab-left>div:nth-child(1)').addClass('xz-top')
        $('.content-top-tab-left>div').each(function () {
          $(this).click(function () {
            $('.content-top-tab-left>div').removeClass('xz-top')
            $(this).addClass('xz-top');

          })
        })
      },200)
      });
    },
    methods: {
      /*切换栏目*/
      /* index:1.追忆 2.追思 3.追寻
      * 1.判断当前栏目是否有值
      * 2.没有请求json 赋值
      * 3.有取值填充
      * */
      _handleObtainData(id) {
        if (id === '1') {
          this.columnId = ZJXLZB
          if (util.isEmpty(this.qmdata)) {
            getzjJsondata().then(res => {
              if (!util.isEmpty(res)) {
                this.isdata = false
                this.qmdata = util.getJsonDetails(res, this.screenfourpage.num);
                this.screenfourpage.dataNum = res[0].pageSize;
                this.screenfourpage.all = Math.ceil(res[0].pageSize / this.screenfourpage.num)
                this.sothelist = this.qmdata;
                this.datalist = this.sothelist['1']
              } else {
                this.isdata = true
                this.datalist = []
              }
            }).catch((err) => {
              this.isdata = true
              this.datalist = []
              console.log(err, "2")
            })
          } else {
            this.isdata = false
            this.sothelist = this.qmdata
            this.datalist = this.sothelist['1']
            this.screenfourpage.dataNum =  this.datalist[0].pageSize;
            this.screenfourpage.all = Math.ceil(this.datalist[0].pageSize / this.screenfourpage.num)
            this.screenfourpage.cur = 1
            console.log(this.datalist + '11')
          }
        } else if (id === '2') {
          this.columnId = ZDLYZB
          if (util.isEmpty(this.zdlydata)) {
            getzdJsondata().then(res => {
              if (!util.isEmpty(res)) {
                this.isdata = false
                this.zdlydata = util.getJsonDetails(res, this.screenfourpage.num);
                this.sothelist = this.zdlydata
                this.datalist = this.sothelist['1']
                this.screenfourpage.dataNum =  this.datalist[0].pageSize;
                this.screenfourpage.all = Math.ceil(res[0].pageSize / this.screenfourpage.num)
                this.screenfourpage.cur = 1
              } else {
                this.isdata = true;
                this.datalist = []
              }
            }).catch((err) => {
              this.isdata = true;
              this.datalist = [];
              console.log(err, "2")
            })
          } else {
            this.isdata = false
            this.sothelist = this.zdlydata
            this.datalist = this.sothelist['1']
            this.screenfourpage.dataNum =  this.datalist[0].pageSize;
            this.screenfourpage.all = Math.ceil(this.datalist[0].pageSize / this.screenfourpage.num)
            this.screenfourpage.cur = 1
          }
        }
        return
      },
      //子级传值到父级上来的动态拿去
      /*
      * 1.判断当前页是否大于要取的页数量
      * 2.大于发取json文件  小于发ajax
      * */
      pageChange: function (page) {
        this.screenfourpage.cur = page;
        let data = {
          columnId: this.columnId,
          pageSize: this.screenfourpage.num,
          pageNum: this.screenfourpage.cur
        };
        if (!this.sothelist[page] || (this.sothelist[page].length < this.screenfourpage.num)) {
          getAjaxdata(data).then((res) => {
            if (res.code == 200 && res.rows) {
              if (res.rows.length > 0) {
                this.isdata = false;
                this.datalist = res.rows;
              } else {
                this.isdata = true;
                this.datalist = []
              }
            } else {
              this.isdata = true
              this.datalist = []
            }
          }).catch((err) => {
            console.log('err' + err)
            /*this.isdata = true*/
          })
        } else {
          this.datalist = this.sothelist[page];
        }
      },
      /*跳转详情页新页面*/
      handleHerf(id) {
        //直接调用$router.push 实现携带参数的跳转
        let routefour = this.$router.resolve({
          path: `/Details/${id}`,
        });
        window.open(routefour.href, '_blank');
      },
      handleTabQx(id) {
        if (id === '1') {
          this.screenfourpage.cur = 1
          this._handleObtainData('1')
        } else if (id === '2') {
          this.screenfourpage.cur = 1
          this._handleObtainData('2')
        }
      }
    }
  }
</script>
<style scoped>
  @media screen and (max-width:1366px) {
    .content-top-tab-left > div {
      font-size: 24px !important;
    }
    .over{
      font-size: 34px !important;
    }
    .resistance-nav-switch li{
      font-size: 34px !important;
    }
    .lstext-text{
      height: 70px !important;
      font-size: 24px !important;
      overflow: hidden;
      line-height: 35px !important;
    }
    .resistance-content ul li > .lstext > .region{
      font-size: 20px !important;
    }

  }

  .Remembrance {
    height: 100%;
    text-align: center;
    box-sizing: border-box;
  }

  .content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .contentnr {
    width: 100%;
    float: left;
  }

  .top {
    position: relative;
    width: 100%;
    height: 226px;
  }

  .over {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 400px;
    line-height: 400px;
    text-align: center;
    color: #aa0000;
    font-size: 25px;

  }

  .top > div {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 1382px;
    height: 193px;
    background: url("../../../assets/img/tophongqi.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 6px;
  }

  .lstext-text {
    height: 50px;
    overflow: hidden;
    font-size: 14px ;
  }

  .resistance-nav {
    width: 1382px;
    display: inline-block;
    text-align: left;
    vertical-align: bottom;
  }

  .resistance-nav-switch {
    float: left;
    text-align: center;
  }

  .resistance-nav-switch li {
    float: left;
    width: 150px;
    height: 46px;
    margin-right: 20px;
    background: url("../../../assets/img/huibuttom.png") no-repeat;
    background-size: 100% 100%;
    font-size: 25px;
    font-family: SourceHanSerifSC-Bold;
    font-weight: normal;
    font-stretch: normal;
    color: rgba(255, 255, 255, 1);
    text-shadow: 0px 3px 3px rgba(67, 0, 0, 0.4);
    line-height: 46px;
    cursor: pointer;
  }

  .resistance-nav-switch li.Select {
    width: 141px;
    height: 55px;
    background: url("../../../assets/img/tap-xz.png");
    background-size: 100% 100%;
  }


  .resistance-content {
    position: relative;
    display: inline-block;
    text-align: center;
    width: 1382px;
  }

  .resistance-content ul {
    width: 100%;
    float: left;
  }

  .resistance-content ul li {
    float: left;
    width: 265px;
    height: 280px;
    margin-right: 2px;
    margin-top: 8px;
    margin-bottom: 40px;
    background-image: url("../../../assets/img/xiangkuang.png");
    background-size: 100% 100%;
    overflow: hidden;
  }

  .resistance-content ul li:nth-child(5n) {
    margin-right: 0 !important;
  }

  .resistance-content ul li > .lsimg {
    margin-left: 2px;
    width: 256.5px  ;
    height: 171px;
  }

  .resistance-content ul li > .lsimg > img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .resistance-content ul li > .lstext {
    width: 260px;
    height: 100px;
    padding:19.7px 19.7px 0  19.7px;
    box-sizing: border-box;
    font-family: MicrosoftYaHei;
    font-size: 16px;
    line-height: 26px;
    color: #000000;
    text-align: left;
    cursor: pointer;
  }

  .resistance-content ul li > .lstext:hover {
    color: #40A9FF;
  }

  .resistance-content ul li > .lstext > .region {
    width: 100%;
    height: 16px;
    font-size: 14px;
    line-height: 30px;
    letter-spacing: 1px;
    color: #302d2d;
    opacity: 0.67;
  }

  .more-regions {
    position: absolute;
    width: 500px;
    top: 40px;
    left: -330px;
    padding: 18px;
    padding-right: 9px !important;
    box-sizing: border-box;
    background-image: linear-gradient(
      #ffffff,
      #ffffff),
    linear-gradient(
      #ffe6c4,
      #ffe6c4);
    background-blend-mode: normal,
    normal;
    box-shadow: 3px 4px 14px 1px rgba(159, 97, 0, 0.5);
    border-radius: 8px;
    border: solid 1px #c2894c;
    z-index: 100000;
  }

  .more-regions ul {
    width: 100%;
    float: left;
    height: 270px;
  }

  .more-regions ul li {
    float: left;
    min-width: 37.5px;
    margin-right: 15px;
    margin-left: 5px;
    margin-bottom: 15px;
  }

  .play {
    position: absolute;
    left: 5px;
    bottom: 5px;
    z-index: 10000;
    background-color: #40a9ff;
    background: url("../../../assets/img/play-red.png") no-repeat;
    width: 30px;
    height: 30px;
    background-size: 100% 100%;
  }

  .rdimg {
    position: absolute;
    left: -20px;
    height: 25px;
    width: 25px;
    top: 0px;
    background: url("../../../assets/img/rd-huang.png");
    background-size: 100% 100%;
  }

  .rdimgjj {
    margin-right: 28px !important;
    padding-left: 5px;
  }

  .content-top-tab {
    margin-top: 50px;
    margin-bottom: 15px;
    width: 1380px;
    display: flex;
    justify-content: left;
  }

  .content-top-tab-left {
    display: flex;
    color: red;
  }

  .content-top-tab-left > div {
    padding: 8px 10px;
    cursor: pointer;
    background-color: #e5b882;
    border-radius: 4px;
    margin-right: 10px;
    font-weight: 700;
    font-size: 16px;
  }

  .content-top-tab-left > div:hover {
    background-color: red;
    color: white;
  }

  .Picture-list {
    width: 194px;
    height: 532px;
    float: left;
  }
  .xz-top{
    background-color: red !important;
    color: white !important;
  }


</style>



// WEBPACK FOOTER //
// src/pages/Home/components/remembrance.vue